/**
 * An enum collection of the possible user events
 *
 * @type {object}
 */
export enum PointerEvents {
  Mousedown = 'mousedown',
  MouseMove = 'mousemove',
  Mouseup = 'mouseup',
  PointerDown = 'pointerdown',
  PointerMove = 'pointermove',
  PointerUp = 'pointerup',
  Touchstart = 'touchstart',
  Touchmove = 'touchmove',
  Touchend = 'touchend',
}

/**
 * The events as obtained from the getPointerEvents() object.
 */
const { Pointerdown, Pointermove, Pointerup } = getPointerEvents();

export { Pointerdown, Pointermove, Pointerup };

/**
 * Computes the earliest pointer events that should fire
 * when a touch occurs.
 */
export function getPointerEvents() {
  const hasPointerEvents = 'onpointerdown' in window;
  const hasTouchEvents = 'ontouchstart' in window;

  let PointerdownEvent: PointerEvents;
  let PointermoveEvent: PointerEvents;
  let PointerupEvent: PointerEvents;

  if (hasPointerEvents) {
    PointerdownEvent = PointerEvents.PointerDown;
    PointermoveEvent = PointerEvents.PointerMove;
    PointerupEvent = PointerEvents.PointerUp;
  } else if (hasTouchEvents) {
    PointerdownEvent = PointerEvents.Touchstart;
    PointermoveEvent = PointerEvents.Touchmove;
    PointerupEvent = PointerEvents.Touchend;
  } else {
    PointerdownEvent = PointerEvents.Mousedown;
    PointermoveEvent = PointerEvents.MouseMove;
    PointerupEvent = PointerEvents.Mouseup;
  }

  return {
    Pointerdown: PointerdownEvent,
    Pointermove: PointermoveEvent,
    Pointerup: PointerupEvent,
  };
}
